import script from "./GradeCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeCategory.vue?vue&type=script&setup=true&lang=js"

import "./GradeCategory.vue?vue&type=style&index=0&id=29990dca&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29990dca"]])

export default __exports__